module.exports = __webpack_public_path__ + "images/lastchance.aa66f654.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/lastchance.jpg
// module id = de9f7bde
// module chunks = 6 16